<template>
  <base-tabs-view
    :tabs="Tabs"
  />
</template>

<script>
import BaseTabsView from '@/components/shared/base/base-tabs-view'
import BaseTabsViewMixin from '@/mixins/base-tabs-view-mixin'

export default {
  name: 'UserManagementRoles',
  components: {
    BaseTabsView
  },
  mixins: [
    BaseTabsViewMixin
  ],
  computed: {
    Tabs () {
      return [
        {
          component: 'user-management-roles-overview',
          idComponent: this.constantMixin.menuItem.userManagement.roles.general,
          name: this.TextMixin_GetTab('overview')
        },
        {
          component: 'user-management-roles-detail',
          disabled: !this.ContentMixin_Element,
          idComponent: this.constantMixin.menuItem.userManagement.roles.general,
          name: this.TextMixin_GetTab(this.BaseTabsViewMixin_GetDetailsTab(), this.TextMixin_GetParameter('userGroup'))
        }
      ]
    }
  }
}
</script>
